export const MAX_DATE_MSG = 'Date should not exceed maximal date';
export const MIN_DATE_MSG = 'Date should not be before minimal date';
export const MAX_DATE = new Date('2100-01-01');
export const MIN_DATE = new Date('1900-01-01');

export const INVALID_DATE_MSG = 'Invalid Date';
